import quickFetch from 'quick-fetch';
import get from 'transmute/get';
import { render } from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import PortalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'disp... Remove this comment to see the full error message
import dispatcher from 'dispatcher/dispatcher';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { DispatcherInstance } from 'general-store';
import { Provider } from 'react-redux';
import HistorySingleton from './routing/records/HistorySingleton';
import { ProvideDataFetchingClient } from 'conversations-inbox-lib/data-fetching-client/public/providers';
import auth from './utils/Auth';
import rootReducer from './reducers/root/adminRootReducer';
import configureStore from './utils/configureStore';
import InboxRoutes from './InboxRoutes';
import FatalError from 'conversations-error-reporting/error-boundaries/components/FatalError';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { setupWithOmnibus } from './omnibus/actions/setupWithOmnibus';
import { startPubSub } from './pubsub/actions/startPubSub';
import { startPrecachePoll } from './assets/inboxAssetCache';
import { makeEarlyRequestData } from './omnibus/operators/makeEarlyRequestData';
import { FETCH_FROM_OMNI_BUS as omnibusActions } from 'conversations-inbox-lib/omnibus/public/constants';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import { InboxReactProfiler } from './utils/InboxReactProfiler';
import { omnibusFulfilled, parseOmnibus } from 'find-and-filter-data/omnibus/public';

// This import is necessary for using any instance of FormattedCurrency or i18n.formatCurrency(), like the instance in the CRM sidebar cards
import 'I18n/init/data/currency';
import { resolveVendor } from './pubsub/resolvers/resolveVendorBuilder';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { VendorResolverProvider as PubSubVendorResolverProvider } from 'conversations-thread-data/pubsub/public/context';
import promiseDone from 'hs-promise-utils/promiseDone';
import { client } from './graphql/client';
import { getCurrentViewId } from 'conversations-inbox-lib/omnibus/public/operators';
import { INBOX_APPLICATION_START } from './performance-metrics/constants/performanceConstants';
import { recordDuration, markAppStartForPerformanceMetrics, startDuration } from './performance-metrics/gatherPerformanceMetrics';
import { getIsHelpDesk } from './urls/getIsHelpDesk';
import ThreadDataProvider from 'conversations-thread-data/common/ThreadDataProvider';
import { parseQueryFromLocation } from './routing/operators/parseQueryFromLocation';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { threadIdFromCVObjectId } from 'conversations-thread-data/cv-object/public';
import { getInboxUrl } from './urls/getInboxUrl';
import { buildError } from 'conversations-error-reporting/error-reporting/builders/buildError';
import { AccessLevelContextProvider } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { renderWithNavCopilot } from 'copilot-toolkit/navCopilot/renderWithNavCopilot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const trackEarlyRequester = usedEarlyRequester => {
  try {
    if (window.newrelic) {
      window.newrelic.setCustomAttribute('conversations-early-requester-succeeded', `${usedEarlyRequester}`);
    }
  } catch (e) {
    // Do nothing
  }
};
export default class InboxApplication {
  start() {
    performance.mark('app start');
    startDuration(INBOX_APPLICATION_START);
    markAppStartForPerformanceMetrics();
    const I18nProvider = createStandardI18nProvider();
    const langReady = Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    const {
      cvObjectId
    } = parseQueryFromLocation(window.location);
    if (cvObjectId) {
      threadIdFromCVObjectId({
        cvObjectId
      }).then(threadId => {
        if (threadId) {
          const url = getInboxUrl(threadId);
          window.location.replace(url);
        }
      }).catch(() => {
        this.renderFatalError();
      });
    }
    startPrecachePoll();
    promiseDone(this.init().then(([omnibusResponse]) => {
      DispatcherInstance.set(dispatcher);
      this.startI18n(I18nProvider);
      return langReady.then(() => {
        const wrappedResolveVendor = () => resolveVendor(() => getCurrentInboxId(this.store.getState()));
        this.startRedux(omnibusResponse, wrappedResolveVendor);
        this.startRouter(wrappedResolveVendor);
      });
    }).catch(error => {
      reportError({
        error
      });
      const browserLanguage = window && window.navigator && window.navigator.languages && window.navigator.languages[0];
      this.startI18n(I18nProvider, browserLanguage);
      return langReady.then(() => {
        if (error.message !== 'Aborting: redirection in progress') {
          this.renderFatalError();
          throw error;
        }
      });
    }).finally(() => {
      recordDuration(INBOX_APPLICATION_START);
    }));
  }
  init() {
    PortalIdParser.get();
    if (getIsHelpDesk()) {
      quickFetch.removeEarlyRequest('omnibus');
      return Promise.all([Promise.resolve(undefined), auth.init()]);
    }
    const earlyWorkspaceRouterRequest = quickFetch.getRequestStateByName('workspace-router');
    if (earlyWorkspaceRouterRequest) {
      earlyWorkspaceRouterRequest.whenFinished(response => {
        try {
          const {
            workspaceType,
            threadId,
            ticketId
          } = JSON.parse(response);
          const ticketPath = ticketId ? `/ticket/${ticketId}` : '';
          const threadPath = threadId ? `/thread/${threadId}` : '';
          if (workspaceType === 'HELPDESK') {
            quickFetch.removeEarlyRequest('omnibus');
            const queryParams = window.location.search;
            window.location.replace(`/help-desk/${PortalIdParser.id}${ticketPath}${threadPath}${queryParams}`);
          }
        } catch (_err) {
          const error = buildError('WORKSPACE_REDIRECT_FAILED', {
            name: 'WorkspaceRedirectError',
            response
          });
          reportError({
            error,
            tags: {
              isVisibleToUser: false
            }
          });
        }
      });
    }
    const omnibusPromise = new Promise(resolve => {
      const earlyRequest = quickFetch.getRequestStateByName('omnibus');
      if (!earlyRequest) {
        if (window.newrelic) {
          window.newrelic.setCustomAttribute('conversations-early-omnibus-missing', 'true');
        }
        // @ts-expect-error ts-migrate(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
        resolve();
      }

      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest('omnibus');
      });
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      earlyRequest.onError((_, statusText) => {
        // @ts-expect-error ts-migrate(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
        resolve();
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        window.newrelic.setCustomAttribute('conversations-early-omnibus-failed', statusText);
        quickFetch.removeEarlyRequest('omnibus');
      });
    });
    return Promise.all([omnibusPromise, auth.init()]);
  }
  startI18n(I18nProvider, defaultLocale) {
    const {
      user,
      portal
    } = auth.get();
    const localeSettings = {
      locale: user ? get('locale', user) : defaultLocale,
      langEnabled: user ? get('lang_enabled', user) : Boolean(defaultLocale),
      timezone: portal ? portal.timezone : undefined
    };
    I18nProvider.setLocale(localeSettings);
  }
  startRedux(omnibusResponse, wrappedResolveVendor) {
    const {
      user,
      gates,
      portal
    } = auth.get();
    const requestArgs = makeEarlyRequestData();
    const incomingThreadId = requestArgs.threadId;
    const initialState = {
      auth: {
        user,
        gates,
        portal
      },
      incomingThreadId
    };
    Raven.setUserContext({
      id: `${get('user_id', user)}`,
      email: get('email', user),
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ id: any; email: any; locale: a... Remove this comment to see the full error message
      locale: get('locale', user)
    });
    if (omnibusResponse) {
      const [findAndFilterOmnibus, remainingOmnibus] = parseOmnibus(omnibusResponse);
      const omnibusAction = {
        type: omnibusActions.SUCCEEDED,
        payload: {
          data: remainingOmnibus,
          requestArgs
        }
      };
      this.store = configureStore(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ auth: { user: any; gates: any;... Remove this comment to see the full error message
      rootReducer(initialState, omnibusAction), rootReducer);
      this.store.dispatch(startPubSub(wrappedResolveVendor));
      this.store.dispatch(setupWithOmnibus(omnibusAction));
      const omnibusViewId = getCurrentViewId(omnibusResponse);
      if (requestArgs.threadList) {
        this.store.dispatch(omnibusFulfilled(findAndFilterOmnibus, `${requestArgs.threadList.threadListType}-${requestArgs.threadList.threadListId}`, requestArgs.inboxId));
      } else if (!requestArgs.threadList && omnibusViewId) {
        this.store.dispatch(omnibusFulfilled(findAndFilterOmnibus, omnibusViewId, requestArgs.inboxId));
      } else {
        const error = buildError('MISSING_THREAD_LIST_INFO_FROM_OMNIBUS', {
          name: 'OmnibusError',
          omnibusResponse
        });
        reportError({
          error,
          tags: {
            isVisibleToUser: false
          },
          extra: {
            omnibusViewId,
            omnibusResponse
          }
        });
      }
      trackEarlyRequester(true);
    } else {
      this.store = configureStore(initialState, rootReducer);
      trackEarlyRequester(false);
    }
  }
  startRouter(wrappedResolveVendor) {
    const history = HistorySingleton().instance();
    const inboxIdRegex = /(&*inbox-id=\d*&*)/gi;
    const inboxIdMatches = window.location.search.match(inboxIdRegex);
    if (inboxIdMatches) {
      const newSearch = window.location.search.replace(inboxIdRegex, '');
      history.replace(`${window.location.pathname}${newSearch}`); //drop any query parameters
    }
    renderWithNavCopilot( /*#__PURE__*/_jsx(PubSubVendorResolverProvider, {
      resolveVendor: wrappedResolveVendor,
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(ThreadDataProvider, {
          children: /*#__PURE__*/_jsx(ApolloProvider, {
            client: client,
            children: /*#__PURE__*/_jsx(ProvideDataFetchingClient, {
              children: /*#__PURE__*/_jsxs(AccessLevelContextProvider, {
                children: [/*#__PURE__*/_jsx(InboxReactProfiler, {}), /*#__PURE__*/_jsx(InboxRoutes, {
                  history: history
                })]
              })
            })
          })
        })
      })
    }), {
      fallbackRenderTarget: document.getElementsByClassName('page')[0],
      layoutType: 'panel-with-scroll'
    });
  }
  renderFatalError() {
    render( /*#__PURE__*/_jsx(FatalError, {}), document.getElementsByClassName('page')[0]);
  }
}